import {Button, Flex} from "antd";
import React from "react";
import {useCurrentUser} from "../../../../contexts/UserContext";
import {useViewerStore} from "../../../../store/store";
import {ArrowsOutCardinalIcon, Plus, TrashIcon} from "@phosphor-icons/react";
import { TbDeviceMobile, TbDeviceMobileRotated } from "react-icons/tb";
import {GetSelModules, ResetSelModuleArr} from "../../../../components/Layout-Components/Editor-Layout/Three-JS-Viewer/Controllers/ModuleControl";
import {registerRef} from "../../../../helpers/storeHelpers";
import { AlertType, ModuleOrientation, SelectType } from "../../../../@types/enums";
import { ModuleMesh } from "../../../../@types/types";

interface ModuleEditOptionsSectionProps {
    handleRemoveModule: (e: React.MouseEvent<HTMLElement>) => void;
    handleMoveModule: (e: React.MouseEvent<HTMLElement>) => void;
}

const ModuleEditOptionsSection: React.FC<ModuleEditOptionsSectionProps> = (props: ModuleEditOptionsSectionProps) => {
    const sceneViewer = useViewerStore(state => state.sceneViewer);

    const {hasCapability} = useCurrentUser();

    const manualZone = useViewerStore((state) => state.manualZone)

    const isMoveModuleActive = useViewerStore((state) => state.isMoveModuleActive)
    const isAddModuleActive = useViewerStore((state) => state.isAddModuleActive)
    const isBallastedRackTypeModuleActive = useViewerStore((state) => state.isBallastedRackTypeModuleActive);
    const modulePlacementStatus = useViewerStore((state) => state.modulePlacementStatus);

    const onClickAdd = (e: React.MouseEvent<HTMLElement>) => {
        if (manualZone) return;
        document.body.style.cursor = "default";
        useViewerStore.setState({isAddModuleActive: !isAddModuleActive, isMoveModuleActive: false})
        if (!isAddModuleActive === true) {
            useViewerStore.setState({isBallastedRackTypeModuleActive: false})
            sceneViewer.selectType = SelectType.module;
            const target = e.target as HTMLElement;
            if (target.classList.contains('disabled')) return;
            sceneViewer.setMoveMode(false);
            sceneViewer.setPushMode(true);
            setModuleDir(sceneViewer.moduleDir);
        } else {
            sceneViewer.setPushMode(false);
        }
    }

    const setModuleDir = (dir: ModuleOrientation) => {
        if(isBallastedRackTypeModuleActive && dir === 'port') {

            sceneViewer.viewerAlert({
                title: 'Cannot set module direction to portrait',
                message: "Ballasted Racked Modules can only be set to landscape",
                messageType: AlertType.error,
                isCloseAfterDisplay: true,
                autoCloseSeconds: 2000,
            });

            return;

        }

        if (manualZone) return;
        const {moveMode} = sceneViewer;
        if (moveMode) return;
        sceneViewer.setModuleSetting('dir', dir);
        const btnPort = document.getElementsByClassName('btnModulePort')[0];
        const btnLand = document.getElementsByClassName('btnModuleLand')[0];
        if (!btnPort || !btnLand) return;
        if (dir === 'port') {
            btnPort.classList.add('active');
            btnLand.classList.remove('active');
        } else if (dir === 'land') {
            btnPort.classList.remove('active');
            btnLand.classList.add('active');
        }
    }

    return (
        <>
            <div className='tab__title'>
                <span className='tab__title--text tab__title--flex'>Module Properties</span>
            </div>

            <div className={`tab__column ${manualZone ? 'disabled' : ''}`}>
                <Flex

                    align='center' justify='center' gap={15}>
                    {hasCapability('Edit_Module_Add') &&
                        <Button
                            ref={registerRef('addModuleBtn')}
                            icon={<Plus size={18}/>}
                            type='default'
                            size='middle'
                            id='addModuleBtn'
                            className={`${isAddModuleActive ? 'active' : ''}`}
                            // className='btnModuleAdd'
                            onClick={e => onClickAdd(e)}
                            style={{width: "85px"}}
                        >Add</Button>
                    }

                    {hasCapability('Edit_Module_Move') &&
                        <Button
                            ref={registerRef('moveModuleBtn')}
                            icon={<ArrowsOutCardinalIcon size={18}/>}
                            type='default'
                            size='middle'
                            id='moveModuleBtn'
                            className={`${isMoveModuleActive ? 'active' : ''}`}
                            onClick={props.handleMoveModule}
                            style={{width: "85px"}}
                        >Move</Button>
                    }

                    {
                        hasCapability('Edit_Module_Remove') &&
                            <Button
                                icon={ <TrashIcon size={18} />}
                                id={"moduleDeleteBtn"}
                                size='middle'
                                onClick={props.handleRemoveModule}
                                property='ModuleDel'
                                style={{width: "85px"}}
                            >Delete</Button>
                    }
                </Flex>

                <Flex align='center' justify='center' gap={15} style={{paddingTop: "10px"}}>
                {
                    hasCapability('Edit_Module_Type') &&
                    <Button
                        title={"Portrait Module"}
                        id={"modulePortDirBtn"}
                    className='orientation-btn btnModulePort'
                    onClick={e => setModuleDir(ModuleOrientation.Portrait)}
                    property='ModulePort'>
                        <TbDeviceMobile size={24}/>
                    </Button>
                }

                {
                    hasCapability('Edit_Module_Type') &&
                    <Button
                        title={"Landscape Module"}
                        id={"moduleLandDirBtn"}
                        className='orientation-btn btnModuleLand'
                        onClick={e => setModuleDir(ModuleOrientation.Landscape)}
                        property='ModuleLand'>
                        <TbDeviceMobileRotated size={24}/>
                    </Button>
                }
                </Flex>

                {/*{showModulePlacementStatus() && modulePlacementStatus !== ModulePlacementStatusOk &&*/}
                {/*    <div className="module-placement-text">*/}
                {/*        Cannot place module on <span>{modulePlacementStatus}</span>*/}
                {/*    </div>*/}
                {/*}*/}
            </div>
        </>
    )
}

export default ModuleEditOptionsSection;
